import React, { Component } from 'react';
import { Jumbotron, Container } from 'reactstrap';
import { Card, Row, Col, Button, CardImg, CardTitle, CardText, CardBody } from 'reactstrap';
import { NavLink as Link } from 'react-router-dom';

import { RenderProgramModal } from './RenderProgramModal'

export class FeaturedPrograms extends Component {

    render() {
        let viewAll;
        let data = this.props.data;
        let cards;
        if (data === undefined | data.length <= 0) {
            if (!this.props.displayMine) {
                cards = <div className="pl-5"><p className="text-color-theme-4 kurb-med">No Programs Available YET! Please Check Back Later! :D</p></div>;
            }
        } else if (this.props.displayFav === true) {
            if (this.props.fav.length === 0) { //no fav item available
                cards = <div className="pl-5"><p className="text-color-theme-4 kurb-med pl-5">You have not favorite any programs yet! Check out some first and come back!</p></div>;
            } else { // some fav item -> filter needed
                let i;
                let j;
                let filteredData = [];
                for (j = 0; j < data.length; j++) {
                    for (i = 0; i < this.props.fav.length; i++) {
                        if (data[j].id === this.props.fav[i]) {
                            filteredData.push(data[j]);
                        }
                    }
                }
                cards = filteredData.map((item) => {
                    return <RenderProgramCard data={item} key={item.id} logInMember={this.props.logInMember} fav={this.props.fav} saveFav={this.props.saveFav} user={this.props.user} />;
                });
            }
        } else {
            // Do we wanna display all cards
            if (this.props.viewAll === "false") {
                let data = this.props.data;
                // Do we wanna display cards that are not the current display card
                if (this.props.currentProgram !== undefined) {
                    let filteredData = data.filter(programObject => programObject !== this.props.currentProgram)
                    data = filteredData;
                }
                viewAll = <Col sm="2" className="d-inline-block text-right kurb-bd pt-2"><p className="mb-0"><Link to="/browse" className="text-white">View All</Link></p></Col>;
                cards = data.slice(0, 3).map((item) => {
                    return <RenderProgramCard data={item} key={item.id} logInMember={this.props.logInMember} fav={this.props.fav} saveFav={this.props.saveFav} user={this.props.user} />;
                });
            } else {
                // display programs created by current organizer on their page
                if (this.props.displayMine) {
                    let organizer = this.props.user.uid;
                    data = data.filter(programObject => programObject.organizer === organizer);
                }

                cards = data.map((item) => {
                    return <RenderProgramCard data={item} key={item.id} logInMember={this.props.logInMember} fav={this.props.fav} saveFav={this.props.saveFav} user={this.props.user} displayMine={this.props.displayMine} removeProgram={this.props.removeProgram} />;
                });
            }
        }

        let addProgramModal = "";

        // only organizations can add programs
        if (this.props.logInOrg & this.props.modal) {
            addProgramModal = <RenderProgramModal data={data} writeNewProgram={this.props.writeNewProgram} />
        }
        return (
            <Jumbotron fluid className="p-5">
                <Container fluid className="pb-2">
                    <Row>
                        <Col sm="10">
                            <h1 className="text-color-theme-1 kurb-bd">{this.props.title}</h1>
                        </Col>
                        {viewAll}
                    </Row>
                </Container>
                <Container fluid>
                    <Row id="program-cards">
                        {cards}
                        {addProgramModal}
                    </Row>
                </Container>
            </Jumbotron>
        );
    }
}



export class RenderProgramCard extends Component {
    // remove a program from firebase based on the program id
    removeProgram = () => {
        this.props.removeProgram(this.props.data.id);
    }

    render() {
        let program = this.props.data;
        let programShortDescription = program.caption.substr(0, 200) + "...";
        let button;

        // only organizations can remove programs
        if (this.props.displayMine) {
            button = <Button color="danger" size="sm" onClick={this.removeProgram}>Remove Program</Button>;
        }
        return (
            <Col sm="12" md="6" lg="4" className="mb-4">
                <Card className="h-100">
                    <CardImg top width="100%" src={program.src} alt="Card image cap" />
                    <CardBody>
                        <CardTitle><h2 className="title-bd font-size-title">{program.header}</h2></CardTitle>
                        <CardText className="body-lt font-size-program-details">{programShortDescription}</CardText>
                    </CardBody>
                    <RenderButtonGroup id={program.id} programObject={program} logInMember={this.props.logInMember} fav={this.props.fav} saveFav={this.props.saveFav} user={this.props.user} />
                    {button}
                </Card>
            </Col>
        );
    }
}

export class RenderButtonGroup extends Component {
    saveFavProgram = () => {
        this.props.saveFav(this.props.id)
    }

    render() {
        let buttonImg;
        let favButton;
        let programDetailsLink = "/programs/" + this.props.id;

        // members can favorite and unfavorite programs
        if (this.props.logInMember) {
            if (this.props.fav === undefined) {
                buttonImg = "../img/white-fav.png";
            } else if (this.props.fav.indexOf(this.props.id) > -1) {
                buttonImg = "../img/white-fav-after.png";
            } else {
                buttonImg = "../img/white-fav.png"
            }
            favButton = <Button onClick={this.saveFavProgram} color="success" size="sm" className="mr-1"><img className="d-inline-block align-bottom" src={buttonImg} alt="Save" /></Button>;
        } else {
            favButton = "";
        }
        return (
            <div className="btn-adjust">
                {favButton}
                <Button tag={Link} color="info" size="sm" to={programDetailsLink}>View Details</Button>
            </div>
        );
    }
}
